
<template>
  <!-- Funcionando ok.. Implementar destruição dos objetos em vuex -->

  <div>
    <v-dialog v-model="dialog" width="500" persistent scrollable>
      <v-card style="border-radius:9px">
        <v-card-title class="pa-0">
          <v-toolbar
            color="primary"
            style="border-top-right-radius:8px;border-top-left-radius:8px"
            dark
          >
            <v-toolbar-title class="white--text">
              <v-icon left>mdi-soccer</v-icon>Desempate
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn color="white" flat icon @click="dialog=false">
              <v-icon>close</v-icon>
            </v-btn>
          </v-toolbar>
        </v-card-title>
        <v-card-text></v-card-text>

        <v-layout row wrap justify-space-around align-center>
          <v-flex xs4 text-xs-center v-if="homeTeam && awayTeam">
            <h2 class="text-xs-center">{{homeTeam.team_name}}</h2>
            <v-layout row wrap justify-center align-center>
              <v-btn
                small
                flat
                icon
                color="red"
                :disabled="goals_tie_breaker[0]==0"
                @click.stop="delTieBreaker(0)"
              >
                <v-icon>remove</v-icon>
              </v-btn>
              {{scoreA}}
              <v-btn small flat icon color="green" @click.stop="addTieBreaker(0)">
                <v-icon>add</v-icon>
              </v-btn>
            </v-layout>
          </v-flex>
          <v-flex xs4 text-xs-center>
            <div class="display-3">X</div>
          </v-flex>
          <v-flex xs4 text-xs-center>
            <h2 class="text-xs-center">{{awayTeam.team_name}}</h2>
            <v-layout row wrap justify-center align-center>
              <v-btn
                small
                flat
                icon
                color="red"
                :disabled="goals_tie_breaker[1]==0"
                @click.stop="delTieBreaker(1)"
              >
                <v-icon>remove</v-icon>
              </v-btn>
              {{scoreB}}
              <v-btn small flat icon color="green" @click.stop="addTieBreaker(1)">
                <v-icon>add</v-icon>
              </v-btn>
            </v-layout>
          </v-flex>
        </v-layout>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn block color="primary" @click="dialog=false, submitGoals()">Ok</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-layout row wrap>
      <v-flex xs12>
        <v-btn block @click="dialog=true" color="primary">
          <v-icon left small dark color="white">fa-unlock</v-icon>Desempate por Pênaltis
        </v-btn>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters, mapMutations } from "vuex";

export default {
  data() {
    return {
      dialog: false,
      teamsTabs: 0,
      headers: [
        { text: "Núm.", align: "center", value: "number" },
        // { text: 'Nome', align: 'center', value: 'name'},
        { text: "Gols", align: "center", value: "goals", sortable: false }
      ],
      goals_tie_breaker: [0, 0]
    };
  },
  methods: {
    addTieBreaker(i) {
      this.$set(this.goals_tie_breaker, i, this.goals_tie_breaker[i] + 1);
    },
    delTieBreaker(i) {
      this.$set(this.goals_tie_breaker, i, this.goals_tie_breaker[i] - 1);
    },
    submitGoals() {
      var breakerPapers = [];
      for (var j = 0; j < this.goals_tie_breaker[0]; j++) {
        const paper = {};
        paper.event_time = null;
        paper.match_id = this.oneMatch.data.id;
        paper.squad_number_id = null;
        paper.champ_team_id = this.homeTeam.id;
        paper.kind = "gol de desempate";
        breakerPapers.push(paper);
      }
      for (var j = 0; j < this.goals_tie_breaker[1]; j++) {
        const paper = {};
        paper.event_time = null;
        paper.match_id = this.oneMatch.data.id;
        paper.squad_number_id = null;
        paper.champ_team_id = this.awayTeam.id;
        paper.kind = "gol de desempate";
        breakerPapers.push(paper);
      }

      this.setBreakerPapers(breakerPapers);
    },

    ...mapMutations({
      setBreakerPapers: "Match/setBreakerPapers"
    })
  },
  computed: {
    scoreA() {
      return this.goals_tie_breaker[0];
    },
    scoreB() {
      return this.goals_tie_breaker[1];
    },

    ...mapGetters({
      homeTeam: "Match/teamA",
      awayTeam: "Match/teamB"
    }),
    ...mapState({
      oneMatch: state => state.Match.oneMatch
    })
  },

  watch: {}
};
</script>

<style scoped>
.CardUser {
  padding: 20px;
}
.icon-stack {
  position: relative;
  display: inline-block;
  width: 2em;
  height: 2em;
  line-height: 2em;
  vertical-align: middle;
}

.icon-stack-1x,
.icon-stack-3x {
  position: absolute;
  left: 0;
  width: 100%;
  text-align: center;
}
.icon-stack-1x {
  line-height: inherit;
}
</style>